module.exports = __webpack_public_path__ + "static/snead-25868a0e44ba6d9908b691725ec9b5a8.png";